export default class User {
  constructor(uuid, name, lastname, role) {
    this.uuid = uuid;
    this.name = name;
    this.lastname = lastname;
    this.role = role;
  }
}

export function getSessionToken() {
  return localStorage.getItem("MedId");
}

export function setSessionToken(token) {
  localStorage.setItem("MedId", token);
}

export function removeSessionToken() {
  localStorage.removeItem("MedId");
}
